import IAvailability from '../../../../../../presentation/interfaces/availability'

const formatAvailability = (availability: IAvailability) => {
  const newFormat: {
    [key: string]: {
      [key: string]: boolean
    }
  }[] = []

  const dayMapping: Record<string, string> = {
    sunday: 'SUNDAY',
    monday: 'MONDAY',
    tuesday: 'TUESDAY',
    wednesday: 'WEDNESDAY',
    thursday: 'THURSDAY',
    friday: 'FRIDAY',
    saturday: 'SATURDAY',
  }

  Object.entries(availability).forEach(([day, value]) => {
    if (value.selected) {
      const newDay: Record<
        string,
        {
          [key: string]: boolean
        }
      > = {}
      newDay[dayMapping[day]] = {
        morning: value.morning,
        afternoon: value.afternoon,
        night: value.evening,
      }
      newFormat.push(newDay)
    }
  })

  return newFormat
}

export default formatAvailability
